module.exports = __webpack_public_path__ + "img/kjs.f2e040dc.png";